var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"fixed","text-align":"left","bottom":"5px","left":"5px","margin":"0px","width":"auto","font-size":"10px","color":"rgba(169, 169, 169, 0.5)","pointer-events":"none"}},[_c('span',[_vm._v("渝ICP备18007262号-1")])])
}]

export { render, staticRenderFns }